/*
 * @description: 自定义js
 * @Author: Jay
 * @Date: 2021-07-23 09:37:49
 * @LastEditors: Jay
 * @LastEditTime: 2026-09-10 14:34:26
 */
import store from '@/store/index.js'
export default {
	//请求头
	api: function () {
		if (process.env.NODE_ENV === "development") {
			// console.log("开发环境")
			return "https://nto.srwkj.com/"
		} else {
			// console.log("生产环境")
			return "https://nto.srwkj.com/"
		}
	},

	//获取用户token
	isToken: function () {
		if (store.state.user.Authorization != '') {
			return store.state.user.Authorization || ''
		}
		return '';
	},

	//上传请求头 登录验证
	uploadParameters: function () {
		return { 'token': this.isToken() }
		// return { 'Authori-zation': 'Bearer ' + this.isToken() }
	},

	// 图片上传接口
	uploadImg: function () {
		return this.api() + 'api2/common/upload'
	},

	/*
		格式化时间 加上时分秒
		num: 后台时间格式
		type: 'YY-MM-DD'年月日 ,'HH-MM-SS'时分秒 ,不传 年月日时分秒
	*/
	happenTime: function (num, type) {
		let date = new Date(num * 1000);
		//时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM; //月补0
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d; //天补0
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h; //小时补0
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m; //分钟补0
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s; //秒补0
		if (type === 'YY-MM-DD') {
			//年月日
			return y + '-' + MM + '-' + d;
		} else if (type === 'HH-MM-SS') {
			//时分秒
			return h + ':' + m + ':' + s;
		} else {
			//全部
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		}
	},

	//手机号 打*
	hidePhone: function (number) {
		let newStr = '';
		newStr = number.substr(0, 3) + "****" + number.substr(7);
		return newStr;
	},

	//全局 隐藏中间位
	hideCentre: function (number, all) {
		// console.log(number);
		let newStr = "";
		if (number == '' || number == undefined) return;
		if (store.state.user.showHide) {
			if (all == 'all') {
				newStr = "********"
			} else {
				newStr = number.substr(0, 3) + '*******' + number.substr(number.length - 4);
			}
			return newStr;
		} else {
			return number;
		}
	},

	/**
	 * 分转元
	 * @param {number} fen - 金额（分）
	 * @returns {string} 格式化后的金额（元）
	  */
	convertPointsYuan: function (fen) {
		if (fen == null || isNaN(fen)) return '0.00';
		// 先转整数避免浮点问题，再除100
		return (Math.round(Number(fen)) / 100).toFixed(2);
	},

	// 跳转外部链接 type = _self 当前页打开 _blank 新窗口打开
	externalLink: function (url, type) {
		window.open(url, type || '_self')
	},

	// 页面回到顶部（滚动效果）
	/*	使用方法
		监听滚动事件
		window.addEventListener('scroll', this.$operate.handleScroll, { once: true }) 
	*/
	handleScroll: function () {
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
		console.log(scrollTop, "scrollTop");
		if (scrollTop > 0) {
			const timeTop = setInterval(() => {
				document.documentElement.scrollTop = document.body.scrollTop = scrollTop -= 50; //一次减50往上滑动
				if (scrollTop <= 0) {
					clearInterval(timeTop);
				}
			}, 10); //定时调用函数使其更顺滑
		}
	},

	//文件下载
	downloadFill(url, name) {
		console.log(url, name);
		let iframe = ''
		try {
			iframe = document.createElement('<iframe name="ifr"></iframe>');
		} catch (e) {
			iframe = document.createElement('iframe');
			iframe.name = name;
		}
		// const a = document.createElement('iframe') //创建a标签
		iframe.style.display = 'none'
		iframe.src = url
		document.body.appendChild(iframe)
	},

	//内容复制
	copyText(data) {
		let oInput = document.createElement('input');
		oInput.value = data;
		document.body.appendChild(oInput);
		oInput.select(); // 选择对象;
		// console.log(oInput.value)
		document.execCommand("Copy");
		oInput.remove()
		return oInput.value
	},
}